export default class NameStringViewModel {
    name: string;
    value: string;

    public constructor(name:string, value: string) {
        this.name = name;
        this.value = value;
    }
}